import { AfterViewChecked, Component, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { paths } from '@app/constants';
import { TouchService } from '@app/core/services/touch/touch.service';
import { Globals } from '@app/shared/models';
import { Store } from '@ngrx/store';
import { State } from '@app/core/features';
import { selectors } from '@app/core/features/charts-store';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@app/shared/components/base/base/base.component';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { isMobileView } from '@app/utils';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent extends BaseComponent implements OnInit, DoCheck, AfterViewChecked {
  public isMobileView : boolean = false;
  activeSlide: SlidesOutputData;
  customOptions: OwlOptions = {
    loop: true,
    autoHeight: false,
    autoWidth: false,
    dots: true,
    items: 1.1,
    dotsEach: 1,
  };
  dataMarketing: any;

  constructor(
    private router: Router,
    // this service is in-use by template, please do not remove
    public touchService: TouchService,
    private globals: Globals,
    protected store: Store<State>,
    ) {
      super();
    }

  ngOnInit() {
    this.handleDataResponse()
  }

  ngDoCheck() {
    this.isMobileView = isMobileView()
  }

  ngAfterViewChecked() {
    setTimeout(() => {
      this.globals.isDisplayProgressSpinner = false;
    });
  }

  private handleDataResponse() {
    this.store
      .pipe(selectors.getData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          let sortedMarketingData = data.marketing.slice(0)
          sortedMarketingData.sort(function (a, b) {
            return parseInt(a['index']) - parseInt(b['index']);
          })
          this.dataMarketing = sortedMarketingData
        }
      })
  }

  public navigateRedeem(event) {
    event.preventDefault();

    this.router.navigate([paths.LIGHT_HOUSE_CHART, paths.REDEEM_VOUCHER], { replaceUrl: false });
  }

  public navigateHowToGuide(event) {
    event.preventDefault();

    this.router.navigate([paths.HOW_TO_GUIDE], { replaceUrl: false });
  }

  getPassedData(data: SlidesOutputData) {
    this.activeSlide = data;
  }
}
